import { storedAttributeProps } from "../html-attributes";
import { Section, Text } from "@react-email/components";
import { getBlockquoteStyles } from "./styles";
export function BlockquoteEmailRenderer(attrs: Record<string, unknown>, children?: React.ReactElement) {
  return <Section {...storedAttributeProps(attrs)} style={getBlockquoteStyles(attrs)}>
      <Text style={{
      margin: "0",
      padding: "0",
      fontStyle: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      color: "inherit"
    }}>
        {children}
      </Text>
    </Section>;
}